import type { NextPage } from 'next'
import Break from 'componentsUnits/break'
import ComponentHeader from 'componentsUnits/componentHeader'
import { Size } from 'types/size'
import { joinClassnames } from 'helpers/classNames'
import styles from './CommunitySC.module.scss'
import { Activity } from 'types/user'
import CommunityComponent from './communityComponent'
import Subtitle from 'componentsUnits/subtitle'
import { EntryDateIndex } from 'reducers/postReducer'
import { Type } from 'types/type'
import { Community } from 'types/community'
import { useAppSelector } from 'reducers/storeHooks'
import { isDev } from 'app/general'

interface Props {
  entryDateIndex: EntryDateIndex[]
  activeInterests?: string[]
  title: string
  showAll?: boolean
  column?: boolean
  showorganiser?: boolean
  activity: Activity
  noEntriesText?: string
  communities?: Community[]
}

const CommunitiesScrollComponent: NextPage<Props> = (props: Props) => {
  const communities = useAppSelector((state) => state.communityReducer.communities)

  const className = joinClassnames([
    styles.component_list_wrapper,
    props.column && styles.column,
  ])

  const createHeader = () => {
    if (props.title !== "" && (communities || (props.communities && props.communities.length > 0)))
      return (
        <ComponentHeader
          title={props.title}
          buttonText={''}
          buttonOnClick={() => {
             isDev && console.log('clicked')
          }}
        />)
    else return <></>
  }

  const createCommunitiesObject = () => {
    let ren: JSX.Element[] = []

    if (props.entryDateIndex) {
      props.entryDateIndex.map((e: EntryDateIndex, i: number) => {
        const community = communities.get(e.entryId);
        if (!community) return (<></>)
        ren.push(
          <div className={styles.CommunityComponent__wrapper} key={i}>
            <CommunityComponent
              showorganiser={props.showorganiser}
              activity={props.activity}
              entryId={community.id}
              community={community}
            />
            {i < (props.entryDateIndex?.length ?? 0) - 1 &&
              <Break />
            }
          </div>
        )
      })
      return ren
    }

    // props.entryDateIndex.map((c: EntryDateIndex, i: number) => {
    //   const community = typeof communities === typeof Map ? communities.get(c.entryId) : null
    //   if (!community) return (<></>)
    //   if (props.showAll) {
    //     ren.push(
    //       <div key={i}>
    //         <CommunityComponent
    //           showorganiser={props.showorganiser}
    //           activity={props.activity}
    //           entryId={c.entryId}
    //           community={community}
    //         />
    //         <Break />
    //       </div>)
    //   }
    //   else if (
    //     isArraysHaveCommonStrings(
    //       props.activeInterests as string[],
    //       community.interests as string[],
    //     )
    //   ) {
    //     ren.push(<CommunityComponent
    //       activity={props.activity} key={i} community={community} entryId={c.entryId} />)
    //   }
    // })
    return ren
  }

  return (
    <div className={styles.container}>
      {props.title && createHeader()}

      <div className={className}>
        {props.entryDateIndex?.length === 0 && props.noEntriesText && (
          <Subtitle text={props.noEntriesText} type={Type.t1} size={Size.xSmall} />
        )}

        {createCommunitiesObject()}
      </div>
    </div>
  )
}

export default CommunitiesScrollComponent
